import { useQuery } from '@apollo/client';
import type { FindNotesArgs } from '../../../types/__generated__/global-types';
import { DAILY_HOTEL_NOTES } from '../gql/gql-daily-notes';

export function useDailyHotelNotes(args: { filters: FindNotesArgs }) {
  return useQuery(DAILY_HOTEL_NOTES, {
    variables: {
      ...args,
    },
    skip: !args.filters.hotelId,
  });
}
